import {
    AfterViewInit,
    Component, EventEmitter,
    Input,
    NgZone,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import mapboxgl from 'mapbox-gl';
import {forEach} from "lodash";
import * as MapboxGl from "mapbox-gl";
import {BranchShipments, ShipmentMarkerProperties, ShipmentsService} from "../services/shipments.service";
import {environment} from "../../environments/environment";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {DriverStatusModalComponent} from "../driver-status-modal/driver-status-modal.component";
import {ShipmentDetailsPopupModalComponent} from "../shipment-details-popup-modal/shipment-details-popup-modal.component";

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

    @Input() routes;
    @Input() pointsCollection: BranchShipments[] = [];
    @Input() drivers: BranchShipments[] = [];
    @Input() branches: BranchShipments[] = [];

    @Input() createDragable: boolean;
    @Input() intialLocation: [number, number];

    @Output() mapClicked = new EventEmitter<any>();
    @Output() markerMoved = new EventEmitter<any>();
    @Output() rightClicked = new EventEmitter<unknown>();

    public map: mapboxgl.Map;
    public loading = true;
    private mapInitialLoad: boolean;
    private mapStyle = 'mapbox://styles/partnerit/cm69w5d5c002e01r5dnqsg3lz';
    private layerId = 'streets-v11';
    private handleError = () => {
    };

    mapClickHandler: (e: mapboxgl.MapMouseEvent) => void;

    public shipmentMarkersLayout: any = {
        'text-field': [
            'get',
            'label_text'
        ],
        'text-font': [
            'DIN Offc Pro Medium',
            'Arial Unicode MS Bold'
        ],
        'text-size': 14,
        'text-offset': [
            0,
            1.6
        ],
        'text-variable-anchor': [
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right'
        ],
        'text-radial-offset': 1.5,
        'text-justify': 'auto',
        'symbol-sort-key': 1,
        'text-optional': true,
        'text-allow-overlap': false,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'text-ignore-placement': false,
        'icon-image': [
            'get',
            'icon_image'
        ],
        'icon-size': 0.5
    }
    private marker: mapboxgl.Marker;
    private driverMarkers:any[]= [];
    private shipmentmarkers:any[]= [];

    protected showDrivers: boolean = true;
    protected showShipments:  boolean = true;


    constructor(
        private ngZone: NgZone,
        public http: HttpClient,
        public ngbModal: NgbModal,
        public shipmentsService: ShipmentsService,
    ) {
        (mapboxgl).accessToken = 'pk.eyJ1IjoicGFydG5lcml0IiwiYSI6ImNrM2lmMm94NjA3NHQzYnI3NnB4YWgybWMifQ.BX0UdXKepb1CaMNF_nsPhQ'
    }

    ngOnInit(): void {
        this.mapClickHandler = this.eventForwareder.bind(this);
    }

    ngAfterViewInit(): void {
        this.ngZone.runOutsideAngular(
            () => {
                this.map = new mapboxgl.Map({
                    container: 'map',
                    style: this.mapStyle,
                    zoom: 5,
                    center: [
                        9.35300,
                        56.09859,
                    ]
                });


                this.map.on('load', () => {
                    console.log('map loaded');
                    this.map.resize();
                    this.map.addControl(new MapboxGl.NavigationControl());


                });

                this.map.on('style.load', () => {
                    this.loadCarrierIcons();
                    this.parsePointsCollection()
                    this.parseRoutes();
                    this.parseDrivers();
                    this.parseBranches();
                    this.createMarker();
                });


            });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.pointsCollection) {
            this.parsePointsCollection()
        }

        if (changes.routes) {
            this.parseRoutes();
        }

        if (changes.drivers) {
            this.parseDrivers();
        }

        if (changes.branches) {
            this.parseDrivers();
        }

        if (changes.intialLocation) {
            this.createMarker();
        }
    }

    public zoomToBound(geojson) {

        if (this.map) {

            const allCordsFlat = geojson.filter(item => item.featureCollection.features.length > 0)
                .map(item => {
                    return item.featureCollection.features;
                }).reduce((acc, item) => {
                if (Array.isArray(item)) {
                    acc.push(...item);
                }
                return acc;
            }, []);

            if (allCordsFlat && allCordsFlat.length > 1) {
                const coordinates = allCordsFlat[0].geometry.coordinates;
                const bounds = allCordsFlat.reduce((newbounds, item) => {
                    return newbounds.extend(item.geometry.coordinates);
                }, new MapboxGl.LngLatBounds(coordinates, coordinates));
                this.map.fitBounds(bounds, {
                    padding: 50
                });
            } else if (allCordsFlat && allCordsFlat.length > 0) {
                this.map.flyTo({center: allCordsFlat[0].geometry.coordinates});
            }
        }
    }


    toggleMapStyle(newstyle) {
        this.ngZone.runOutsideAngular(
            () => {
                this.map.setStyle(newstyle);
            }
        );
    }


    private parseRoutes() {

        if (!this.map) {
            return;
        }

        if (!this.routes) {
            return;
        }

        console.log('parseRoutes');
        this.ngZone.runOutsideAngular(() => {

            this.routes.forEach((route, i) => {
                this.map.addSource('routeSource-' + i, {
                    type: 'geojson',
                    data: route.featureCollection,
                    cluster: false,
                    tolerance: 0,
                });

                this.map.addLayer({
                    id: 'routes-layer-' + i,
                    source: 'routeSource-' + i,
                    type: 'line',
                    layout: {'line-join': 'round', 'line-cap': 'round'},
                    paint: {'line-color': route.color, 'line-width': 2}
                });

                this.map.addLayer({
                    id: 'arrows-layer-' + i,
                    source: 'routeSource-' + i,
                    type: 'symbol',
                    layout: {
                        'icon-allow-overlap': true,
                        'text-allow-overlap': true,
                        'symbol-placement': 'line',
                        'text-field': '▶',
                        'text-size': [
                            'interpolate',
                            ['linear'],
                            ['zoom'],
                            12, 24,
                            22, 60
                        ],
                        'symbol-spacing': [
                            'interpolate',
                            ['linear'],
                            ['zoom'],
                            12, 30,
                            22, 160
                        ],
                        'text-keep-upright': false
                    },
                    paint: {
                        'text-color': '#FFFFFF',
                        'text-halo-color': route.color,
                        'text-halo-width': 1
                    }
                });
            })

        })
    }

    private parsePointsCollection() {

        if (!this.map) {
            return;
        }

        if (!this.pointsCollection) {
            return;
        }

        this.shipmentmarkers.forEach(marker => {
            marker.remove();
        })

        if (!this.showShipments) {
            return;
        }

        this.parseShipmentMarkerImages();
                const spiderfier = new MarkerSpiderfier(this.map);
        this.pointsCollection.forEach((item, i) => {

            item.featureCollection.features.forEach((featureCollectionElement) => {

                if (!featureCollectionElement.properties.id) {
                    return;
                }
                const markerEl = this.addShipmentMarker( featureCollectionElement.properties);
                const marker = new mapboxgl.Marker({element: markerEl, anchor: 'top-left'})
                    .setLngLat(featureCollectionElement.geometry.coordinates as [number, number])
                    .addTo(this.map)
                ;

                spiderfier.addMarker(marker, featureCollectionElement.geometry.coordinates as [number, number]);
                // this.map.on('click', () => spiderfier.unspiderfyAll());

                this.shipmentmarkers.push(marker);

            });

        //
        //     this.map.off('click', 'icons-' + i, this.mapClickHandler);
        //     this.map.off('contextmenu', 'icons-' + i, this.mapClickHandler);
        //     this.ngZone.runOutsideAngular(() => {
        //
        //         if (this.map.getSource('shipmentSource-' + i)) {
        //             this.map.removeLayer('circles-' + i);
        //             this.map.removeLayer('acircles-' + i);
        //             this.map.removeLayer('icons-' + i);
        //             this.map.removeSource('shipmentSource-' + i);
        //         }
        //         this.map.addSource('shipmentSource-' + i, {
        //             type: 'geojson',
        //             data: item.featureCollection,
        //             cluster: false,
        //             tolerance: 0,
        //             clusterMaxZoom: 14,
        //             clusterRadius: 60,
        //         });
        //
        //         this.map.addLayer({
        //             id: 'circles-' + i,
        //             source: 'shipmentSource-' + i,
        //             type: 'circle',
        //             paint: item.paint,
        //             filter: ['has', 'point_count']
        //         });
        //
        //         this.map.addLayer({
        //             id: 'acircles-' + i,
        //             source: 'shipmentSource-' + i,
        //             type: 'symbol',
        //             paint: item.paint,
        //             filter: ['has', 'point_count'],
        //             layout: {
        //                 'symbol-sort-key': 50,
        //                 'text-field': '{point_count_abbreviated}',
        //                 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        //                 'text-size': 12
        //             }
        //         });
        //
        //         this.map.addLayer({
        //             id: 'icons-' + i,
        //             source: 'shipmentSource-' + i,
        //             type: 'symbol',
        //             paint: {
        //                 'text-color': [
        //                     'get',
        //                     'text_color'
        //                 ],
        //                 'text-halo-color': 'hsl(0,0%,100%)',
        //                 'text-halo-blur': 1,
        //                 'text-halo-width': 900
        //             },
        //             filter: ['!', ['has', 'point_count']],
        //             layout: this.shipmentMarkersLayout,
        //         });
        //
        //
        //     });
        //     this.map.on('click', 'icons-' + i, this.mapClickHandler);
        //     this.map.on('contextmenu', 'icons-' + i, this.mapClickHandler);
        //
        //     this.map.on('click', 'circles-' + i, (event) => {
        //
        //         const features = this.map.queryRenderedFeatures(event.point, {
        //             layers: ['circles-' + i]
        //         });
        //
        //         const clusterId = features[0].properties.cluster_id;
        //         const source = this.map.getSource('shipmentSource-' + i) as mapboxgl.GeoJSONSource;
        //         source.getClusterExpansionZoom(clusterId, (err, zoom) => {
        //                 if (err) {
        //                     return;
        //                 }
        //
        //                 if (features[0].geometry?.type === 'Point') {
        //
        //                     this.map.easeTo({
        //                         // @ts-ignore
        //                         center: features[0].geometry.coordinates,
        //                         zoom: zoom
        //                     });
        //                 }
        //             }
        //         );
        //     });
        });

        if (this.pointsCollection) {
            this.zoomToBound(this.pointsCollection);
        }
    }


    parseShipmentMarkerImages() {

        if (!this.map) {
            return;
        }

        if (!this.pointsCollection) {
            return;
        }

        this.ngZone.runOutsideAngular(() => {

            // this.imageLoaded = false;
            this.pointsCollection.forEach((item) => {
                item.featureCollection.features.forEach((feature) => {

                        /**
                         *
                         */
                        if (feature.properties.icon_image) {
                            this.map.loadImage(feature.properties.icon_image, (error, result) => {
                                if (!this.map.hasImage(feature.properties.icon_image)) { // @todo we need to load all point icons from the same source dir ?
                                    try {
                                        this.map.addImage(feature.properties.icon_image, result);
                                    } catch (e) {
                                    }
                                    // this.imageLoaded = true;
                                } else {
                                    // this.imageLoaded = true;
                                }
                            });
                        }
                    }
                )
            })
        })
    }


    private loadCarrierIcons() {

        const icons = [{id: 'icon-df', url: environment.assetBase + '/assets/img/map-icons-alternate/carrier-df.png'},
            {id: 'icon-postnord', url: environment.assetBase + '/assets/img/map-icons-alternate/carrier-postnord.png'},
            {
                id: 'icon-gls',
                url: environment.assetBase + '/assets/img/map-icons-alternate/carrier-gls.png'
            }].map(icon => {
            this.map.loadImage(
                icon.url,
                (error, image) => {
                    if (error) {
                        throw error;
                    }
                    this.map.addImage(icon.url, image);
                });
        })


    }

    ngOnDestroy() {
        console.log('destroying map');
    }


    private parseBranches() {
        if (!this.map) {
            return;
        }

        if (!this.branches) {
            return;
        }

        this.ngZone.runOutsideAngular(() => {
            this.branches.forEach((branch, i) => {
                this.map.addSource('branchSource' + i, {
                    type: 'geojson',
                    data: branch.featureCollection,
                    cluster: false,
                    tolerance: 0,
                });

                const imageId = 'branch-icon-' + i;
                const imageUrl = environment.assetBase + 'assets/img/branches/' + branch.featureCollection.features[0].properties.icon
                this.map.loadImage(imageUrl, (error, result) => {
                    if (!this.map.hasImage(imageId)) {
                        try {
                            this.map.addImage(imageId, result);
                        } catch (e) {
                        }
                    } else {
                    }
                });

                this.map.addLayer({
                    id: 'branch-points-layer-' + i,
                    source: 'branchSource' + i,
                    type: 'symbol',
                    layout: {
                        'text-field': [
                            'get',
                            'label_text'
                        ],
                        'text-font': [
                            'DIN Offc Pro Medium',
                            'Arial Unicode MS Bold'
                        ],
                        'text-size': 12,
                        'text-offset': [
                            0,
                            1.3
                        ],
                        'text-variable-anchor': [
                            'top',
                            'bottom',
                            'left',
                            'right',
                            'top-left',
                            'top-right',
                            'bottom-left',
                            'bottom-right'
                        ],
                        'text-radial-offset': 0.5,
                        'text-justify': 'auto',
                        'text-allow-overlap': true,
                        'icon-ignore-placement': true,
                        'text-ignore-placement': true,
                        'symbol-sort-key': 100,
                        'icon-allow-overlap': true,
                        'icon-image': 'branch-icon-' + i,
                        'icon-size': 0.15
                    }
                })
            })
        })
    }

    addShipmentMarker = (properties: ShipmentMarkerProperties) => {

        const labelEl = document.createElement('span');
        labelEl.innerHTML = properties.label_text;

        const routeEl = document.createElement('div');
        routeEl.style.width = '10px';
        routeEl.style.height = '10px';
        routeEl.style.borderRadius = '50%';
        routeEl.style.background = properties.route_color;
        if (!properties.route_color) {
            routeEl.style.border = '1px solid black';
        }

        const markerEl = document.createElement('div');
        markerEl.style.zIndex = '1000';
        markerEl.style.display = 'flex';
        markerEl.style.alignItems = 'center';
        markerEl.style.justifyContent = 'space-between';
        markerEl.style.gap = '1rem';
        markerEl.style.gap = '5px';
        markerEl.style.padding = '2px';
        markerEl.style.border = '1px solid black';
        markerEl.style.borderRadius = '50%';
        markerEl.style.borderRadius = '5px';
        markerEl.style.background = 'white';
        markerEl.style.border = '3px solid ' + properties.text_color;

        const orderLinesEle = document.createElement('span');
        orderLinesEle.innerHTML = '<i class="fa-solid fa-barcode-read"></i> ' + properties.shipment_lines_count;

        const weightSumEle = document.createElement('span');
        if (properties.weight_warning) {
            weightSumEle.style.color = 'red';
        }
        weightSumEle.innerHTML = '<i class="fa-solid fa-weight-hanging"></i> ' + properties.weight_sum + ' kg';


        markerEl.appendChild(routeEl);
        markerEl.appendChild(labelEl);
        markerEl.appendChild(orderLinesEle);
        markerEl.appendChild(weightSumEle);

        markerEl.addEventListener('contextmenu', (e) => {
            this.ngZone.run(() => {
                if (this.shipmentsService?.paintData?.active) {
                    this.rightClicked.emit(properties.id);
                }
            });
        });
        markerEl.addEventListener('click', (e) => {
            e.stopPropagation();
            this.ngZone.run(() => {
                const modalRef = this.ngbModal.open(ShipmentDetailsPopupModalComponent, {size: 'xl'});
                modalRef.componentInstance.modal = modalRef;
                modalRef.componentInstance.shipmentId = properties.id;
            });
        });


        return markerEl;
    }

    addRotatingMarker = (direction, text, speed, driverId) => {


        const labelEl = document.createElement('span');
        labelEl.innerHTML = text + (speed ? ' - ' + speed + ' km/h' : '');

        const markerEl = document.createElement('div');
        markerEl.style.display = 'flex';
        markerEl.style.gap = '5px';
        markerEl.style.padding = '2px';
        markerEl.style.border = '1px solid black';
        markerEl.style.borderRadius = '5px';
        markerEl.style.background = 'white';

        if (direction) {

            const arrowEl = document.createElement('div');
            arrowEl.style.width = '20px';
            arrowEl.style.height = '20px';
            arrowEl.style.background = 'red';
            arrowEl.style.clipPath = 'polygon(50% 0%, 25% 100%, 75% 100%)'; // Triangle shape
            arrowEl.style.transform = `rotate(${direction}deg)`; // Apply rotation
            arrowEl.style.transformOrigin = 'center center';
            markerEl.appendChild(arrowEl);
        } else {
            const arrowEl = document.createElement('div');
            arrowEl.style.width = '20px';
            arrowEl.style.height = '20px';
            arrowEl.style.background = 'blue';
            arrowEl.style.color = 'white';
            arrowEl.style.textAlign = 'center';
            arrowEl.style.borderRadius = '5px';
            arrowEl.innerHTML = 'P';
            markerEl.appendChild(arrowEl);
        }


        markerEl.appendChild(labelEl);

        markerEl.addEventListener('click', (e) => {
            e.stopPropagation();
            this.ngZone.run(() => {
                const modalRef = this.ngbModal.open(DriverStatusModalComponent, {size: 'lg'});
                modalRef.componentInstance.modal = modalRef;
                modalRef.componentInstance.driverId = driverId;
            });
        });

        return markerEl;
    };


    private parseDrivers() {


        if (!this.map) {
            return;
        }

        this.driverMarkers.forEach(marker => {
            marker.remove();
        })

        if (!this.showDrivers) {
            return;
        }

        this.ngZone.runOutsideAngular(() => {

            this.drivers.forEach((driver, i) => {
                if (this.map.getSource('driverSource' + i)) {
                   this.map.removeLayer('driver-points-layer-' + i);
                    this.map.removeSource('driverSource' + i);
                }

           //    this.map.addSource('driverSource' + i, {
           //        type: 'geojson',
           //        data: driver.featureCollection,
           //        cluster: false,
           //        tolerance: 0,
           //    });

           //    const imageId = 'driver-icon-' + i;
           //    const imageUrl = environment.assetBase + '/assets/img/truck-' + driver.featureCollection.features[0].properties.branch + '-' + driver.featureCollection.features[0].properties.driver + '.png';

           //   this.map.loadImage(imageUrl, (error, result) => {
           //       if (!this.map.hasImage(imageId)) {
           //           try {
           //               this.map.addImage(imageId, result);
           //           } catch (e) {
           //           }
           //       } else {
           //       }
           //   });

                // this.map.on('click', 'driver-points-layer-' + i, (item) => {
                //     if (item['used']) {
                //         return;
                //     }
                //     this.ngZone.run(() => {
                //         const modalRef = this.ngbModal.open(DriverStatusModalComponent, {size: 'lg'});
                //         modalRef.componentInstance.modal = modalRef;
                //         modalRef.componentInstance.driverId = item.features![0].properties?.id;
                //
                //     });
                //     item['used'] = true;
                // });

                const markerEl = this.addRotatingMarker(
                    driver.featureCollection.features[0].properties.direction,
                    driver.featureCollection.features[0].properties.driver_name,
                    driver.featureCollection.features[0].properties.speed,
                    driver.featureCollection.features[0].properties?.id
                );
                const marker = new mapboxgl.Marker({element: markerEl, anchor: 'top-left'})
                    .setLngLat(driver.featureCollection.features[0].geometry.coordinates as [number, number])
                    .addTo(this.map);

                this.driverMarkers.push(marker);

                // this.map.addLayer({
                //     id: 'driver-points-layer-' + i,
                //     source: 'driverSource' + i,
                //     type: 'symbol',
                //     layout: {
                //         // 'text-field': [
                //         //     'get',
                //         //     'driver_name'
                //         // ],
                //         // 'text-font': [
                //         //     'DIN Offc Pro Medium',
                //         //     'Arial Unicode MS Bold'
                //         // ],
                //         // 'text-size': 12,
                //         // 'text-offset': [
                //         //     0,
                //         //     1.3
                //         // ],
                //         // 'text-variable-anchor': [
                //         //     'top',
                //         //     'bottom',
                //         //     'left',
                //         //     'right',
                //         //     'top-left',
                //         //     'top-right',
                //         //     'bottom-left',
                //         //     'bottom-right'
                //         // ],
                //         // 'text-radial-offset': 0.5,
                //         // 'text-justify': 'auto',
                //         // 'text-allow-overlap': true,
                //         'icon-ignore-placement': true,
                //         'text-ignore-placement': true,
                //         'symbol-sort-key': 100,
                //         'icon-allow-overlap': true,
                //         'icon-image': 'driver-icon-' + i,
                //         'icon-size': 0.7
                //     }
                // });


            })
        })

    }

    eventForwareder(e) {
        this.ngZone.run(() => {
            this.mapClicked.emit(e);
        })
    }

    private createMarker() {

        if (!this.map) {
            return;
        }

        if (this.createDragable) {
            this.ngZone.runOutsideAngular(() => {

                if (this.marker) {
                    this.marker.remove();
                }

                this.marker = new mapboxgl.Marker({
                    draggable: true
                })
                    .setLngLat(this.intialLocation)
                    .addTo(this.map);
                this.marker.on('dragend', () => {
                    const lngLat = this.marker.getLngLat();
                    this.ngZone.run(() => {
                        this.markerMoved.emit(lngLat);
                    })
                });
            });
        }
    }

    protected toggleDriverVisibility() {
        this.showDrivers = !this.showDrivers;
        this.parseDrivers();
    }

    protected toggleShipmentVisibility() {
        this.showShipments = !this.showShipments;
        this.parsePointsCollection();
    }
}

type SpiderfiedMarker = {
    marker: mapboxgl.Marker;
    originalLngLat: mapboxgl.LngLatLike;
};

export class MarkerSpiderfier {
    private spiderfiedGroups = new Map<string, SpiderfiedMarker[]>();

    constructor(private map: mapboxgl.Map) {}

    private keyForLngLat(lngLat: mapboxgl.LngLatLike): string {
        const ll = mapboxgl.LngLat.convert(lngLat);
        return `${ll.lng.toFixed(6)}:${ll.lat.toFixed(6)}`;
    }

    addMarker(marker: mapboxgl.Marker, lngLat: mapboxgl.LngLatLike): void {
        marker.setLngLat(lngLat);
        const key = this.keyForLngLat(lngLat);

        const group = this.spiderfiedGroups.get(key) ?? [];

        group.push({ marker, originalLngLat: lngLat });
        this.spiderfiedGroups.set(key, group);

        marker.getElement().addEventListener('click', (e) => {
            e.stopPropagation();
            this.spiderfyGroup(key);
        });
    }

    spiderfyGroup(key: string): void {
        const group = this.spiderfiedGroups.get(key);
        if (!group || group.length < 2) return;

        const center = mapboxgl.LngLat.convert(group[0].originalLngLat);
        const centerPoint = this.map.project(center);

        const count = group.length;
        const radius = Math.max(35, Math.min(70, 18 + count * 6));
        const angleStep = (Math.PI * 2) / count;

        group.forEach((item, index) => {
            const angle = index * angleStep;
            const x = centerPoint.x + Math.cos(angle) * radius;
            const y = centerPoint.y + Math.sin(angle) * radius;

            const lngLat = this.map.unproject([x, y]);
            item.marker.setLngLat(lngLat);

            const el = item.marker.getElement();
            el.style.zIndex = String(1000 + index);
            el.classList.add('spiderfied-marker');
        });
    }

    unspiderfyAll(): void {
        for (const group of this.spiderfiedGroups.values()) {
            group.forEach((item) => {
                item.marker.setLngLat(item.originalLngLat);
                const el = item.marker.getElement();
                el.style.zIndex = '';
                el.classList.remove('spiderfied-marker');
            });
        }
    }

    unspiderfyGroup(key: string): void {
        const group = this.spiderfiedGroups.get(key);
        if (!group) return;

        group.forEach((item) => {
            item.marker.setLngLat(item.originalLngLat);
            const el = item.marker.getElement();
            el.style.zIndex = '';
            el.classList.remove('spiderfied-marker');
        });
    }
}
